//Importamos librerias
import axios from "axios";
import api from '@/../static/js/api'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import enumeraciones from '@/../static/js/enumeraciones'

//Creamos la variable de común
const comun = {}

comun.DescargarDocumentoPDF= (vinculo)=> {
 if(vinculo!=null){
      let nombreArchivo =(vinculo!=null)? vinculo.split('\\').pop():"";
      const SERVIDOR = api.conexion;
      let datos = {rutaDelArchivo:vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,'\\\\themisfstest')}
      const parametros = new URLSearchParams(datos); //Comun/Funciones/DescargaArchivo
      const METODO_API_AGREGAR = `${api.Comun.funcion.DescargarArchivo}?${parametros}`
      let urlApi = SERVIDOR + METODO_API_AGREGAR;
      console.log("urlApi::",urlApi)
      axios.get(urlApi,{responseType: 'arraybuffer'})
      .then(response => {
        const blob = new Blob([response.data], {type: 'application/pdf'});
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, nombreArchivo);
        }
        else{
          const elem = window.document.createElement('a');
          elem.href = window.URL.createObjectURL(blob);
          elem.download = nombreArchivo;       
          document.body.appendChild(elem);
          elem.click();        
          document.body.removeChild(elem);
        }
      }).catch(err => {
        console.log("err::",err)
        if(err.response.status = 404){
        console.clear();
        }
        comun.mensajeDeAlerta("El documento no esta disponible", null, null);
      })

  } else{
    comun.mensajeDeAlerta("La ruta del archivo no se a encontrado", null, null);
  }

};



//Asignamos los datos necesarios del común
comun.mensajeDeAlerta = (mensaje, nombreDeFuncion, datos) => {
  $('.bootbox.modal').modal('hide');
  bootbox.alert({
    title: "Mensaje del sistema",
    message: mensaje,
    buttons: {
      ok: {
        label: 'Aceptar'
      }
    },
    callback: function () {
      if (nombreDeFuncion != null && nombreDeFuncion != undefined) {
        var fn = window[funcion];
        if (datos != null && data != undefined) {
          if (typeof fn === "function") fn.apply(null, datos);
        } else {
          if (typeof fn === "function") fn();
        }
      }
    }
  });
};
comun.mensajeDeConfirmacion = (mensaje, textoDeCancelacion, textoDeConfirmacion, nombreDeFuncionSi, datosSi, nombreDeFuncionNo, datosNo) => {
  $('.bootbox.modal').modal('hide');
  bootbox.confirm({
    title: "Mensaje del sistema",
    message: mensaje,
    buttons: {
      cancel: {
        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + textoDeCancelacion
      },
      confirm: {
        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + textoDeConfirmacion
      }
    },
    callback: function (respuesta) {
      if (respuesta) {
        if (nombreDeFuncionSi != null && nombreDeFuncionSi != undefined) {
          var fn = window[nombreDeFuncionSi];
          if (datosSi != null) {
            if (typeof fn === "function") fn.apply(null, datosSi);
          } else {
            if (typeof fn === "function") fn();
          }
        }
      } else {
        if (nombreDeFuncionNo != null && nombreDeFuncionNo != undefined) {
          var fn = window[nombreDeFuncionNo];
          if (datosNo != null) {
            if (typeof fn === "function") fn.apply(null, datosNo);
          } else {
            if (typeof fn === "function") fn();
          }
        }
      }
    }
  });
};
comun.mensajeDeError = (error, campo) => {
  switch(error){
    case "500":
      return "Ha sucedido un error en el sistema" + (campo === undefined ? "" : " al cargar las opciones de '" + campo + "'") + ". Inténtelo de nuevo.<br />Si el problema persiste, no cierre la pantalla y contacte a soporte (Ext. 4420 o 4494) para notificar este problema.";
    default:
      return "No se ha encontrado el objeto " + (campo === undefined ? "referenciado" : "'" + campo + "'") + ". Inténtelo de nuevo.<br />Si el problema persiste, no cierre la pantalla y contacte a soporte (Ext. 4420 o 4494) para notificar este problema.";
  }
};
comun.YaEstaADondeSeEstaDirigiendo = (router, ruta, direccionABuscar) => {
  if(direccionABuscar != null && direccionABuscar != undefined) {
    if(router.history.pending != undefined) {
      if(router.history.pending.fullPath.search(direccionABuscar) < 0)
        return false;
    } else if(router.currentRoute.fullPath.search(direccionABuscar) < 0) {
      return false;
    }

    return true;
  } else {
    if(router.history.pending != undefined) {
      if(router.history.pending.fullPath != ruta)
        return false;
    } else if(router.currentRoute.fullPath != ruta) {
      return false;
    }

    return true;
  }
};

comun.CrearElHeaderDeAutorizacion = (autorizacionEnTexto, subirArchivos, descargarArchivos) => {  
  const header = {
    headers: {},
    responseType: ''
  }

  header.headers["Access-Control-Allow-Origin"] = "*";

  if(autorizacionEnTexto != undefined && autorizacionEnTexto != undefined && autorizacionEnTexto != "") {
    const autenticacion = JSON.parse(autorizacionEnTexto);
    header.headers.Authorization = autenticacion.Token;
    header.headers.Expiration = autenticacion.ExpirationDate;
  }

  if(subirArchivos == true) {
    header.headers["Content-Type"] = 'multipart/form-data';
    header.headers["Accept"] = 'application/json';
  }

  if(descargarArchivos) {
    header.responseType = 'arraybuffer'
  }

  return header;
};
comun.EsNecesarioRecargarLaPagina = (esNecesario) => {
  if(esNecesario) {
    $("#recargardatosdelasesion").removeClass("d-none");
    $("#recargardatosdelasesion").addClass("d-flex");
    $("#user").addClass("d-none");
    $("#user").removeClass("d-flex");
    $("#menuizquierda_noticias").addClass("d-none");
    $("#menuizquierda_usuario").addClass("d-none");
    $("#notificacion").addClass("d-none");
    $("#notificacion").removeClass("d-flex");
    $("#cerrarsesion").addClass("d-none");
    $("#cerrarsesion").removeClass("d-flex");
  } else {
    $("#recargardatosdelasesion").addClass("d-none");
    $("#recargardatosdelasesion").removeClass("d-flex");
    $("#user").removeClass("d-none");
    $("#user").addClass("d-flex");
    $("#menuizquierda_noticias").removeClass("d-none");
    $("#menuizquierda_usuario").removeClass("d-none");
    $("#notificacion").addClass("d-flex");
    $("#notificacion").removeClass("d-none");
    $("#cerrarsesion").addClass("d-flex");
    $("#cerrarsesion").removeClass("d-none");
  }
};
comun.EsNecesarioElTablero = (esNecesario) => {
  if(esNecesario) {
    $("#tablero").removeClass("d-none");
    $("#tablero").addClass("d-flex");
  } else {
    $("#tablero").addClass("d-none");
    $("#tablero").removeClass("d-flex");
  }
};
comun.EsNecesarioCambiarLaContrasena = (contrasenaVerificada) => {
  if(contrasenaVerificada == true) {
    $("#contrasenaNoValidada_div").addClass("d-none");
    $("#contrasenaNoValidada_div").removeClass("d-flex");
  } else if (contrasenaVerificada == false) {
    $("#contrasenaNoValidada_div").removeClass("d-none");
    $("#contrasenaNoValidada_div").addClass("d-flex");
  } else {
    $("#contrasenaNoValidada_div").addClass("d-none");
    $("#contrasenaNoValidada_div").removeClass("d-flex");
  }
};
comun.SeEstaIniciandoSesion = (iniciandoSesion) => {
  if(iniciandoSesion){
    $("#tituloDelInicioDeSesion").html("INICIANDO SESIÓN");
    $("#datosParaIniciarSesion").addClass("d-none");
    $("#iniciandoSesion").addClass("d-flex");
    $("#iniciandoSesion").removeClass("d-none");
  } else {
    $("#tituloDelInicioDeSesion").html("INICIAR SESIÓN");
    $("#iniciandoSesion").addClass("d-none");
    $("#datosParaIniciarSesion").removeClass("d-none");
    $("#iniciandoSesion").removeClass("d-flex");
  }
}
comun.SeEstaRecargandoLaSesion = (recargandoSesion) => {
  if(recargandoSesion) {
    $("#mensajededatosdelasesion").html("Cargando sesión");
    $("#recargandodatosdelasesion").addClass("fa-spin");
    $("#recargardatosdelasesion").addClass("negarelclick");
    
  } else {
    $("#mensajededatosdelasesion").html("Recarga la sesión");
    $("#recargandodatosdelasesion").removeClass("fa-spin");
    $("#recargardatosdelasesion").removeClass("negarelclick");
  }
};
comun.ConAutenticacion = (conAutenticacion) => {
  if(!conAutenticacion) {
    comun.SeEstaRecargandoLaSesion(false);
    comun.EsNecesarioRecargarLaPagina(true);
    comun.EsNecesarioElTablero(false);
    $("#dirigiralogin").addClass("d-flex");
    $("#dirigiralogin").removeClass("d-none");
    $("#recargardatosdelasesion").addClass("d-none");
    $("#recargardatosdelasesion").removeClass("d-flex");
  }
}
comun.SeEstaCargandoInformacion = (seEstaCargandoInformacion, esEnLaPaginaWeb) => {
  if(seEstaCargandoInformacion) {
    $("#" + (esEnLaPaginaWeb == null || esEnLaPaginaWeb == undefined ? "cargandoInformacion_div" : "cargandoInformacionPaginaWeb_div")).addClass("d-flex");
    $("#" + (esEnLaPaginaWeb == null || esEnLaPaginaWeb == undefined ? "cargandoInformacion_div" : "cargandoInformacionPaginaWeb_div")).removeClass("d-none");
  } else {
    $("#" + (esEnLaPaginaWeb == null || esEnLaPaginaWeb == undefined ? "cargandoInformacion_div" : "cargandoInformacionPaginaWeb_div")).addClass("d-none");
    $("#" + (esEnLaPaginaWeb == null || esEnLaPaginaWeb == undefined ? "cargandoInformacion_div" : "cargandoInformacionPaginaWeb_div")).removeClass("d-flex");
  }
};
comun.CreaElListadoParaBootboxPrompt = (listadoDeDatos, tipoDeSelectId, nombreDelId) => {
  let listadoConfigurado = [];

  switch(tipoDeSelectId) {
    case enumeraciones.tiposDeSelect.Seleccione.Id:
      listadoConfigurado.push({
        value: '',
        text: enumeraciones.tiposDeSelect.Seleccione.Nombre + " una opción"
      })
      break;
    case enumeraciones.tiposDeSelect.Todos.Id:
      listadoConfigurado.push({
        value: '',
        text: enumeraciones.tiposDeSelect.Todos.Nombre
      })
      break;
    case enumeraciones.tiposDeSelect.Todas.Id:
      listadoConfigurado.push({
        value: '',
        text: enumeraciones.tiposDeSelect.Todas.Nombre
      })
      break;
  }

  listadoDeDatos.forEach(function(dato, indice) {
    listadoConfigurado.push({
      value: dato[nombreDelId],
      text: dato.Nombre
    })
  })

  return listadoConfigurado;
};
comun.EsCorreoElectronico = (email, soloPrimeraSeccion) => {
  let regex = "";

  if(soloPrimeraSeccion == true)
      regex = /^([a-zA-Z0-9_.+-])/;
  else
      regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  return regex.test(email);
}
comun.CalcularElTamanoDesdeBytes = (bytes, decimales = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;

  const dm = decimales < 0 ? 0 : decimales;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(totalK));

  return parseFloat((bytes / Math.pow(totalK, i)).toFixed(dm)) + ' ' + sizes[i];
}

//Exportamos los datos de común
export default comun;



//////////////////
// WEBPACK FOOTER
// ./static/js/comun.js
// module id = DDaq
// module chunks = 2